module.exports = __webpack_public_path__ + "font/fontello.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/_mavon-editor@2.9.1@mavon-editor/dist/font/fontello.woff
// module id = 44
// module chunks = 0